module.exports = __webpack_public_path__ + "static/media/introduce_base2.24ad1308.png";